export default {
	sec_01: {
		title: {
			one: 'JP WORLD Pay ',
			two: 'card',
		},
		desc: {
			one: 'You can easily access your JP WORLD Pay balance',
			two: 'with debit and prepaid cards or fund your daily purchases',
			three: 'with one of your credit offerings.',
		},
	},
	sec_08: {
		title: 'JP WORLD Pay Credit',
		one: {
			desc: {
				one: 'Buy now and pay over time.',
				two: 'Get special financing for purchases over',
				three: '10,000 yen wherever JP WORLD Pay is allowed.',
			},
			btn: 'Learn about JP WORLD Pay Credits',
		},
		two: {
			desc: {
				one: 'There is no interest if you pay the',
				two: 'full amount within 6 months for every 10,000 yen purchase.',
				three: 'If you do not pay your balance in full within six months,',
				four: 'interest will be charged to your account from the date of purchase.',
				five: 'A minimum monthly payment is required. Subject to credit approval',
			},
			btn: 'JP WORLD PAY Cash Card Information',
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'NEW',
				two: 'JP WORLD Pay',
				three: 'Cashback (JPYS Coin)',
			},
			desc: {
				one: 'Unlimited 3% cashback when purchasing JP WORLD Pay',
				two: 'Get unlimited 2% for all other purchases.',
				three: 'Be the first to find out when you can use it.',
				four: 'Previous 2% cashback holders do not need to join the list.',
				five: 'You will receive an automatic upgrade.',
			},
			btn: 'Learn about JP WORLD Pay Credits',
		},
		two: {
			title: {
				one: 'JP WORLD Pay',
				two: 'Cash Card',
			},
			desc: {
				one: 'You can easily manage',
				two: 'your funds by accessing them with a',
				three: 'debit card connected to your JP WORLD Pay balance.',
			},
			btn: 'View Terms and Conditions',
		},
	},
	common: {
		coming_soon: 'Coming soon.',
	},
};
